export default __webpack_public_path__ + "static/media/jcb_inverse.06c31fa0.svg";